<!-- tasks start -->
<div class="flex flex-col">
  <!--  -->
  <div
    [columns]="defaultColumns"
    *ngFor="let task of dataSource?.data; let isLast = last"
    task-row-wide
    [showFilesButton]="false"
    [showCommentsButton]="false"
    [showCommandMenu]="false"
    class="bg-white border-gray border-b last:border-none"
    [task]=task>
  </div>
</div>
<nx-empty-box
  *ngIf="!dataSource?.data || dataSource?.data?.length === 0"
  [label]="'Keine Aufgaben gefunden.'">
</nx-empty-box>
<!-- tasks end -->

<!-- Pagination start -->
<p-paginator
  *ngIf="dataSource?.totalElements > 5"
  [dropdownAppendTo]="'body'"
  [totalRecords]="dataSource?.totalElements"
  [first]="pageModel?.pageNumber * pageModel?.pageSize"
  [rows]="pageModel?.pageSize"
  [showCurrentPageReport]="true"
  (onPageChange)="onPageChange($event)" 
  currentPageReportTemplate="{first} - {last} von {totalRecords}"
  [rowsPerPageOptions]="[5, 10]">
</p-paginator>
<!-- Pagination end -->